import { useState, useCallback } from 'react';
import { getTickets, getTicketById, createTicket as apiCreateTicket } from '@/api/tickets';
import { safeToLowerCase } from '@/utils/stringUtils';

export const useTickets = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTickets = useCallback(async (filters: any) => {
    setLoading(true);
    setError(null);
    try {
      const response = await getTickets(filters);
      return response;
    } catch (err: any) {
      setError(err.message || 'Failed to fetch tickets');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchTicketDetails = useCallback(async (id: string) => {
    setLoading(true);
    setError(null);
    try {
      const response = await getTicketById(id);
      return response;
    } catch (err: any) {
      setError(err.message || 'Failed to fetch ticket details');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const createTicket = useCallback(async (ticketData: any) => {
    setLoading(true);
    setError(null);
    try {
      const newTicket = await apiCreateTicket(ticketData);
      return newTicket;
    } catch (err: any) {
      const data = err.response?.data;
      let message = data?.message || err.message || 'Failed to create ticket';

      if (data?.errors) {
        const details = Object.values(data.errors).flat().join(', ');
        if (details) {
            if (safeToLowerCase(message).includes('validation')) {
                 message = `${message}: ${details}`;
            } else {
                 message = details;
            }
        }
      }
      setError(message);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  // Placeholder for getTicketStatisticsByPeriod
  const getTicketStatisticsByPeriod = useCallback(async (period: string) => {
      console.log("Fetching stats for", period)
      // Mock data
      return Promise.resolve({ total: 0, open: 0, closed: 0, pending: 0, new: 0, resolved: 0, amounts: {} });
  }, []);


  return {
    loading,
    error,
    getTickets: fetchTickets,
    getTicketDetails: fetchTicketDetails,
    createTicket,
    getTicketStatisticsByPeriod
  };
};
